import styled from "styled-components";
import FormSimpleSelect from "@src/Components/Common/FormFields/FormSimpleSelect/FormSimpleSelect";
import { Grid } from "@material-ui/core";

export const STFormSimpleSelect = styled(FormSimpleSelect).attrs({
  classes: { root: "root" },
})`
  && {
    .root {
      min-width: 150px;
    }
  }
`;

export const STGrid = styled(Grid)`
  && {
    padding-top: 8px;
  }
`;
